/*eslint-disable no-template-curly-in-string*/
/*eslint-disable no-useless-escape*/

import { DateRangeType } from "../../../common/enums/DRCXEnums";
import { DataTypeEnum } from "../../../common/enums/DataTypeEnum";
import { SetPointTypeEnum } from "../../../common/enums/SetpointTypeEnum";
import { SetPointVarianceTimeframeEnum } from "../../../common/enums/SetpointVarianceTimeframeEnum";
import { SetPointVarianceTypeEnum } from "../../../common/enums/SetpointVarianceTypeEnum";
import { TimeframeTypeEnum } from "../../../common/enums/TimeframeTypeEnum";
import { eLynxObjectTypeEnum } from "../../../common/enums/eLynxObjectType";
import { getTimeframeTimeDisplayText } from "../../../common/utilities/TimeframeUtilities";
import i18n from "../../../services/localization-service/i18n";
import { ITagProperties } from "../../../services/properties-data-service/Models";
import { IReferenceMessageDTO, IReferenceUnitOfMeasureDTO } from "../../../services/setpoint-administration-service/Models";
import { SetpointFormType } from "../AlarmSetpointEditorUtils";


export enum MessageTemplateTypeEnum  {
    AlarmSubject = 0,
    AlarmMessage = 1,
    ClearSubject = 2,
    ClearMessage = 3,
    VoiceAlarmMessage = 4,
    VoiceClearMessage = 5
}

const sampleTag: ITagProperties = {
    id: -1,
    deviceDisplayName: "<OBJECT NAME>",
    objectName: "<TAG NAME>",
    objectType: eLynxObjectTypeEnum.Tag,
    lastKnownValue: {
        displayText:  "<TAG VALUE>"
    },
    unitName: "<TAG UNIT OF MEASURE>",
    deviceLocation: '<WELL API ID>'
};


function _replaceTokenWithValue(source: string, token: string, value: string): string {

    let result = source;
    let leaveWhile = false;

    do {

        const replaceResult = result.replace(token, value);

        // If nothing changed there is nothing else to replace
        leaveWhile = (replaceResult === result);

        result = replaceResult;

    } while (!leaveWhile);

    return result;
}

// function getValue(setpoint: IEditDTO): number {

//     if (setpoint.isDiscrete || setpoint.dataType === DataTypeEnum.String) {
//         return 0;
//     }


//     this.valueComparisonValue = Number(this.valueComparisonValue);
//         this.varianceComparisonValue = Number(this.varianceComparisonValue);

//         const comparisonType = this.getComparisonType();

//         return (setpoint.comparisonType === SetPointTypeEnum.ValueComparison)
//             ? setpoint
//             : setpoint.varthis.varianceComparisonValue;

// }


const AlarmSetpointMessagingUtils = {
    

    formatSampleMessage: (setpoint: SetpointFormType, template: string, uoms: IReferenceUnitOfMeasureDTO[], tag?: ITagProperties): string => {

        const tagProperties = tag ?? {...sampleTag};

        let sampleText = "";

        const templateCopy = (template && template.trim().length > 0)
            ? template.trim()
            : undefined;

        if (templateCopy) {

            sampleText = templateCopy;
            
            let varianceType = "<VARIANCE TYPE>";
            let varianceWindow = "<VARIANCE WINDOW>";
            let timespanUnit = "<TIMESPAN UNIT>";

            if (setpoint.comparisonType === SetPointTypeEnum.VariationAmount ||
                setpoint.comparisonType === SetPointTypeEnum.VariationPercent) {

                switch (setpoint.varianceType) {

                    case SetPointVarianceTypeEnum.Decrease:
                        varianceType = i18n.t("setpointAdmin.messaging.sampleTextSnipets.varianceTypeDecrease");
                        break;

                    case SetPointVarianceTypeEnum.Increase:
                        varianceType = i18n.t("setpointAdmin.messaging.sampleTextSnipets.varianceTypeEither");
                        break;

                    case SetPointVarianceTypeEnum.Either:
                        varianceType = i18n.t("setpointAdmin.messaging.sampleTextSnipets.varianceTypeIncrease");
                        break;

                }

                switch (setpoint.varianceTimeframeType) {
                    case SetPointVarianceTimeframeEnum.Days:
                        varianceWindow = `${setpoint.varianceWindow} ${i18n.t("setpointAdmin.varianceTimeframe.day")}`;
                        break;

                    case SetPointVarianceTimeframeEnum.Hours:
                        varianceWindow = `${setpoint.varianceWindow} ${i18n.t("setpointAdmin.varianceTimeframe.hour")}`;
                        break;

                    case SetPointVarianceTimeframeEnum.Months:
                        varianceWindow = `${setpoint.varianceWindow} ${i18n.t("setpointAdmin.varianceTimeframe.month")}`;
                        break;
                }
            }

            if(setpoint.comparisonType === SetPointTypeEnum.TimeComparison) {
                switch (setpoint.timespanType) {
                    case DateRangeType.Minute:
                        timespanUnit = i18n.t("setpointAdmin.timeComparisonTimeSpan.minutes");
                        break;
                    case DateRangeType.Hour:
                        timespanUnit = i18n.t("setpointAdmin.timeComparisonTimeSpan.hours");
                        break;
                    case DateRangeType.Day:
                        timespanUnit = i18n.t("setpointAdmin.timeComparisonTimeSpan.days");
                        break;
                }
            }

            const uomItem = uoms.find(o => o.id === setpoint.unitOfMeasureID);
            tagProperties.unitName = uomItem?.name ?? '';
            if (uomItem?.name.toLowerCase() === 'undefined') {
                uomItem.name = '';
            }

            //rms 2018-12-13
            //the tag model knows nothing about well properties nor even the object type to which the tag belongs
            //therefore we have to do some cheating here
            sampleText = _replaceTokenWithValue(template, "${CurrentObject.ObjectName}", tagProperties.deviceDisplayName);
            sampleText = _replaceTokenWithValue(sampleText,"${Device.ObjectName}", tagProperties.deviceDisplayName);
            sampleText = _replaceTokenWithValue(sampleText, "${NewValue}", tagProperties.lastKnownValue.displayText ?? '');
            sampleText = _replaceTokenWithValue(sampleText, "${NewValueUnit}", tagProperties.unitName);
            sampleText = _replaceTokenWithValue(sampleText, "${PreviousValue}", tagProperties.lastKnownValue.displayText ?? '');
            sampleText = _replaceTokenWithValue(sampleText, "${PreviousValueUnit}", tagProperties.unitName);
            sampleText = _replaceTokenWithValue(sampleText, "${SetPoint.ObjectName}", setpoint.setPointName);
            sampleText = _replaceTokenWithValue(sampleText, "${SetPoint.Operator}", setpoint.operator);


            sampleText = _replaceTokenWithValue(sampleText, "${SetPointValue}",
                                setpoint.dataType === DataTypeEnum.Double ? 
                                    setpoint.value.toString()
                                    : 
                                    setpoint.textValue);

            //well properties
            sampleText = _replaceTokenWithValue(sampleText, "${Well.ObjectName}", tagProperties.deviceDisplayName);
            sampleText = _replaceTokenWithValue(sampleText, "${Well.ApiID}", tagProperties.deviceLocation ?? '');
            sampleText = _replaceTokenWithValue(sampleText, "${TankBattery.ObjectName}", tagProperties.deviceDisplayName);

            // const uomItem = Enumerable
            //     .from(this._referenceData.unitsOfMeasure)
            //     .firstOrDefault(uom => Number(uom.id) === this.setPoint.getUnitOfMeasureID());

            sampleText = _replaceTokenWithValue(sampleText, "${SetPointValueUnit}", uomItem?.name ?? "");
            sampleText = _replaceTokenWithValue(sampleText, "${Tag.ObjectName}", tagProperties.objectName ?? '');
            sampleText = _replaceTokenWithValue(sampleText, "${Timestamp}", getTimeframeTimeDisplayText(TimeframeTypeEnum.None, new Date()));
            sampleText = _replaceTokenWithValue(sampleText, "${VarianceType}", varianceType);
            sampleText = _replaceTokenWithValue(sampleText, "${VarianceWindow}", varianceWindow);

            sampleText = _replaceTokenWithValue(sampleText, "${TimespanUnit}", timespanUnit);
           

            //since this loop may be a bit slow, see if there are any templates left to process
            const regex = /\${[\S]*Attributes\./;

            if (regex.test(sampleText)) {
                let obj = (tagProperties.parentObjectTypeID === eLynxObjectTypeEnum.Well ? 
                    "Well" : 
                    tagProperties.parentObjectTypeID === eLynxObjectTypeEnum.TankBattery ? 
                    "TankBattery" 
                    : "Device");

                tagProperties.parentAttributes?.forEach((a => {
                    sampleText = _replaceTokenWithValue(sampleText, `$\{${obj}Attributes.${a.an}\}`, a.av)}));
            }
        }

        return sampleText;
    },
    getMessageTemplates: (templateType: MessageTemplateTypeEnum, dataType: DataTypeEnum, messages: IReferenceMessageDTO[]): IReferenceMessageDTO[] => {

        switch (templateType) {
            case MessageTemplateTypeEnum.AlarmSubject:
                return messages.filter(o => o.isSubject && !o.isClearOnly &&
                    !o.objectType && o.dataType === dataType &&
                    o.friendlyName.toLowerCase().indexOf('well name') === -1 &&
                    o.friendlyName.toLowerCase().indexOf('device name') === -1 && 
                    o.friendlyName.toLowerCase().indexOf('tankbattery name') === -1)
                    .sort((a, b) => (a.friendlyName as string).localeCompare(b.friendlyName as string));

            case MessageTemplateTypeEnum.AlarmMessage:
                return messages.filter(o => o.isBody && !o.isClearOnly &&
                    !o.objectType && o.dataType === dataType &&
                    o.friendlyName.toLowerCase().indexOf('well name') === -1 &&
                    o.friendlyName.toLowerCase().indexOf('device name') === -1 && 
                    o.friendlyName.toLowerCase().indexOf('tankbattery name') === -1)
                    .sort((a, b) => (a.friendlyName as string).localeCompare(b.friendlyName as string));

            case MessageTemplateTypeEnum.ClearSubject:
                return messages.filter(o => o.isSubject && !o.isAlarmOnly &&
                    !o.objectType && o.dataType === dataType &&
                    o.friendlyName.toLowerCase().indexOf('well name') === -1 &&
                    o.friendlyName.toLowerCase().indexOf('device name') === -1 && 
                    o.friendlyName.toLowerCase().indexOf('tankbattery name') === -1)
                    .sort((a, b) => (a.friendlyName as string).localeCompare(b.friendlyName as string));

            case MessageTemplateTypeEnum.ClearMessage:
                return messages.filter(o => o.isBody && !o.isAlarmOnly &&
                    !o.objectType && o.dataType === dataType &&
                    o.friendlyName.toLowerCase().indexOf('well name') === -1 &&
                    o.friendlyName.toLowerCase().indexOf('device name') === -1 && 
                    o.friendlyName.toLowerCase().indexOf('tankbattery name') === -1)
                    .sort((a, b) => (a.friendlyName as string).localeCompare(b.friendlyName as string));

            case MessageTemplateTypeEnum.VoiceAlarmMessage:
                return messages.filter(o => !o.isClearOnly &&
                    !o.objectType && o.dataType === dataType &&
                    o.friendlyName.toLowerCase().indexOf('well name') === -1 &&
                    o.friendlyName.toLowerCase().indexOf('device name') === -1 && 
                    o.friendlyName.toLowerCase().indexOf('tankbattery name') === -1)
                    .sort((a, b) => (a.friendlyName as string).localeCompare(b.friendlyName as string));


            case MessageTemplateTypeEnum.VoiceClearMessage:
                return messages.filter(o => !o.isAlarmOnly &&
                    !o.objectType && o.dataType === dataType &&
                    o.friendlyName.toLowerCase().indexOf('well name') === -1 &&
                    o.friendlyName.toLowerCase().indexOf('device name') === -1 && 
                    o.friendlyName.toLowerCase().indexOf('tankbattery name') === -1)
                    .sort((a, b) => (a.friendlyName as string).localeCompare(b.friendlyName as string));

            default: 
                return [];
        }
    },
    getFormPropertyName: (templateType: MessageTemplateTypeEnum): 
        'emailAlarmMessageSubject' | 'emailAlarmMessageBody' |
        'emailClearMessageSubject' | 'emailClearMessageBody' |
        'voiceAlarmMessageBody' |  'voiceClearMessageBody' => {
        
    return templateType === MessageTemplateTypeEnum.AlarmSubject ?
                        'emailAlarmMessageSubject' :
                        templateType === MessageTemplateTypeEnum.AlarmMessage ?
                        'emailAlarmMessageBody' :
                        templateType === MessageTemplateTypeEnum.ClearSubject ?
                        'emailClearMessageSubject' :
                        templateType === MessageTemplateTypeEnum.ClearMessage ? 
                        'emailClearMessageBody' :
                        templateType === MessageTemplateTypeEnum.VoiceAlarmMessage ?
                        'voiceAlarmMessageBody' :
                        'voiceClearMessageBody';
    },
    getFormPropertySampleName: (templateType: MessageTemplateTypeEnum): 
        'sampleEmailAlarmMessageSubject' | 'sampleEmailAlarmMessageBody' |
        'sampleEmailClearMessageSubject' | 'sampleEmailClearMessageBody' |
        'sampleVoiceAlarmMessageBody' |  'sampleVoiceClearMessageBody' => {
        
    return templateType === MessageTemplateTypeEnum.AlarmSubject ?
                        'sampleEmailAlarmMessageSubject' :
                        templateType === MessageTemplateTypeEnum.AlarmMessage ?
                        'sampleEmailAlarmMessageBody' :
                        templateType === MessageTemplateTypeEnum.ClearSubject ?
                        'sampleEmailClearMessageSubject' :
                        templateType === MessageTemplateTypeEnum.ClearMessage ? 
                        'sampleEmailClearMessageBody' :
                        templateType === MessageTemplateTypeEnum.VoiceAlarmMessage ?
                        'sampleVoiceAlarmMessageBody' :
                        'sampleVoiceClearMessageBody';
    },
    getFormPropertyLabel: (templateType: MessageTemplateTypeEnum): string => {

        switch(templateType) {
            case MessageTemplateTypeEnum.AlarmSubject:
            case MessageTemplateTypeEnum.ClearSubject:
                return i18n.t('setpointAdmin.messaging.subject');

            case MessageTemplateTypeEnum.AlarmMessage:
            case MessageTemplateTypeEnum.ClearMessage:
                return i18n.t('setpointAdmin.messaging.body');

            case MessageTemplateTypeEnum.VoiceAlarmMessage:
            case MessageTemplateTypeEnum.VoiceClearMessage:
                return i18n.t('setpointAdmin.messaging.voice');

            default:
                return '';
        }
    }

    // function _formatSampleText(template: string | undefined): string {

    //     let sampleText = "";

    //     template = (template && template.trim().length > 0)
    //         ? template.trim()
    //         : undefined;

    //     if (template !== null) {

    //         let varianceType = "";
    //         let varianceWindow = "";

    //         if (this.setPoint.getComparisonType() !== SetPointTypeEnum.ValueComparison) {

    //             switch (this.setPoint.getVarianceComparisonType()) {

    //                 case SetPointVarianceTypeEnum.Decrease:
    //                     varianceType = i18n.t("setPointAdmin.addEditDialog.propertiesTab.messageVisualizationSection.sampleTextSnipets.varianceTypeDecrease");
    //                     break;

    //                 case SetPointVarianceTypeEnum.Increase:
    //                     varianceType = i18n.t("setPointAdmin.addEditDialog.propertiesTab.messageVisualizationSection.sampleTextSnipets.varianceTypeEither");
    //                     break;

    //                 case SetPointVarianceTypeEnum.Either:
    //                     varianceType = i18n.t("setPointAdmin.addEditDialog.propertiesTab.messageVisualizationSection.sampleTextSnipets.varianceTypeIncrease");
    //                     break;

    //             }

    //             const varianceTimeframeType = <SetPointVarianceTimeframeEnum>Number(this.setPoint.varianceComparisonTimeframeType);
    //             switch (varianceTimeframeType) {
    //                 case SetPointVarianceTimeframeEnum.Days:
    //                     varianceWindow = `${this.setPoint.varianceComparisonWindow} ${i18n.t("setPointVarianceTimeframe.day")}`;
    //                     break;

    //                 case SetPointVarianceTimeframeEnum.Hours:
    //                     varianceWindow = `${this.setPoint.varianceComparisonWindow} ${i18n.t("setPointVarianceTimeframe.hour")}`;
    //                     break;

    //                 case SetPointVarianceTimeframeEnum.Months:
    //                     varianceWindow = `${this.setPoint.varianceComparisonWindow} ${i18n.t("setPointVarianceTimeframe.month")}`;
    //                     break;

    //             }
    //         }

    //         //rms 2018-12-13
    //         //the tag model knows nothing about well properties nor even the object type to which the tag belongs
    //         //therefore we have to do some cheating here
           
            
    //         sampleText = this._replaceTokenWithValue(template, "${CurrentObject.ObjectName}", this.tagModel.deviceDisplayName);
    //         sampleText = this._replaceTokenWithValue(sampleText,"${Device.ObjectName}", this.tagModel.deviceDisplayName);
    //         sampleText = this._replaceTokenWithValue(sampleText, "${NewValue}", this.tagModel.lastKnownValue.displayText);
    //         sampleText = this._replaceTokenWithValue(sampleText, "${NewValueUnit}", this.tagModel.unitName);
    //         sampleText = this._replaceTokenWithValue(sampleText, "${PreviousValue}", this.tagModel.lastKnownValue.displayText);
    //         sampleText = this._replaceTokenWithValue(sampleText, "${PreviousValueUnit}", this.tagModel.unitName);
    //         sampleText = this._replaceTokenWithValue(sampleText, "${SetPoint.ObjectName}", this.setPoint.name);
    //         sampleText = this._replaceTokenWithValue(sampleText, "${SetPoint.Operator}", this.setPoint.getOperator());


    //         sampleText = this._replaceTokenWithValue(sampleText, "${SetPointValue}",
    //             this.setPoint.dataType === DataTypeEnum.Double
    //                 ? String(this.setPoint.getValue())
    //                 : this.setPoint.getTextValue());

    //         //well properties
    //         sampleText = this._replaceTokenWithValue(sampleText, "${Well.ObjectName}", this.tagModel.deviceDisplayName);
    //         sampleText = this._replaceTokenWithValue(sampleText, "${Well.ApiID}", this.tagModel.deviceLocation);

    //         sampleText = this._replaceTokenWithValue(sampleText, "${TankBattery.ObjectName}", this.tagModel.deviceDisplayName);

    //         const uomItem = Enumerable
    //             .from(this._referenceData.unitsOfMeasure)
    //             .firstOrDefault(uom => Number(uom.id) === this.setPoint.getUnitOfMeasureID());

    //         sampleText = this._replaceTokenWithValue(sampleText, "${SetPointValueUnit}",
    //             (uomItem !== null) ? uomItem.name : "undefined");


    //         sampleText = this._replaceTokenWithValue(sampleText, "${Tag.ObjectName}", this.tagModel.objectName);

    //         sampleText = this._replaceTokenWithValue(sampleText, "${Timestamp}", moment(Date.now()).format("L LTS"));
    //         sampleText = this._replaceTokenWithValue(sampleText, "${VarianceType}", varianceType);
    //         sampleText = this._replaceTokenWithValue(sampleText, "${VarianceWindow}", varianceWindow);
           

    //         //since this loop may be a bit slow, see if there are any templates left to process
    //         const regex = /\${[\S]*Attributes\./;
    //         if (regex.test(sampleText)) {
    //             let obj = (54 === this.tagModel.parentObjectTypeID ? "Well" : this.tagModel.parentObjectTypeID === eLynxObjectTypeEnum.TankBattery ? "TankBattery" : "Device");
    //             Enumerable.from(this.tagModel.parentAttributes)
    //                 .forEach((a => {sampleText = this._replaceTokenWithValue(sampleText, `$\{${obj}Attributes.${a.attributeName}\}`, a.attributeValue)}));
    //         }
    //     }

    //     return sampleText;

    // }


}

export default AlarmSetpointMessagingUtils;